<script setup lang="ts">
definePageMeta({
  title: 'Contact Us',
})
</script>

<template>
  <template>
    <div class="py-24 bg-gray-50 dark:bg-gray-950 min-h-screen">
      <UContainer>
        <div class="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto items-start">
          <!-- Contact Info -->
          <div>
            <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-6">Get in touch</h1>
            <p class="text-gray-600 dark:text-gray-400 text-lg mb-8">
              Have a question about our courses or technical issues? We're here to help.
            </p>

            <div class="space-y-6">
              <div class="flex items-start gap-4">
                <div class="p-3 bg-primary-100 dark:bg-primary-900/30 rounded-lg text-primary-600">
                  <UIcon name="i-heroicons-envelope" class="w-6 h-6" />
                </div>
                <div>
                  <h3 class="font-semibold text-gray-900 dark:text-white">Email</h3>
                  <p class="text-gray-500">support@comepass.app</p>
                </div>
              </div>

              <div class="flex items-start gap-4">
                <div class="p-3 bg-primary-100 dark:bg-primary-900/30 rounded-lg text-primary-600">
                  <UIcon name="i-heroicons-chat-bubble-left-right" class="w-6 h-6" />
                </div>
                <div>
                  <h3 class="font-semibold text-gray-900 dark:text-white">Live Chat</h3>
                  <p class="text-gray-500">Available Mon-Fri, 9am-5pm EST</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Contact Form -->
          <UCard class="shadow-xl">
            <form class="space-y-4" @submit.prevent>
              <div class="grid grid-cols-2 gap-4">
                <UFormField label="First name" name="firstname">
                  <UInput placeholder="John" />
                </UFormField>
                <UFormField label="Last name" name="lastname">
                  <UInput placeholder="Doe" />
                </UFormField>
              </div>

              <UFormField label="Email" name="email">
                <UInput type="email" placeholder="john@example.com" icon="i-heroicons-envelope" />
              </UFormField>

              <UFormField label="Message" name="message">
                <UTextarea placeholder="How can we help you?" :rows="4" />
              </UFormField>

              <UButton type="submit" color="primary" block size="lg" class="mt-2">
                Send Message
              </UButton>
            </form>
          </UCard>
        </div>
      </UContainer>
    </div>
  </template>
</template>
